import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import {
  FilterFormActions,
  FilterFormClearButton,
  FilterFormSubmitButton,
} from 'components/filters/FilterFormButtons';
import useFilterFormContextApplyFiltersStoredValues from 'components/filters/useFilterFormContextApplyFiltersStoredValues';
import useFilterFormContextFormHandlers from 'components/filters/useFilterFormContextFormHandlers';
import DateTimePickerField from 'components/forms/dateTimePickerField/DateTimePickerField';
import PropertyMultiSelectField from 'components/forms/domain/property/PropertyMultiSelectField/PropertyMultiSelectField';
import { Form } from 'components/forms/form/Form';
import CommonFiltersContainer from 'pages/automations/common/CommonFiltersContainer';
import ActionTypeMultiSelectField from 'pages/automations/triggers/filters/fields/ActionTypeMultiSelectField';
import { AVAILABLE_FILTER_ACTIONS } from './MessageLogTabFilters.constants';
import { MessageLogTabFiltersSchemaType } from './MessageLogTabFilters.schema';
import MessageLogSearchField from './fields/MessageLogSearchField';
import StatusMultiSelectField from './fields/StatusMultiSelectField';
import useSearchedMessageLog from './useSearchedMessageLog';

const MessageLogTabFilters = () => {
  const { t } = useTranslation();
  const { handleClear, handleSubmit } =
    useFilterFormContextFormHandlers<MessageLogTabFiltersSchemaType>();
  const isSearchActive = !!useSearchedMessageLog();

  useFilterFormContextApplyFiltersStoredValues();

  return (
    <CommonFiltersContainer
      searchField={<MessageLogSearchField />}
      stateStorageKey="message-log-tab-filters-expanded"
    >
      <Form
        data-testid="message-log-tab-filters-form"
        horizontal
        onSubmit={handleSubmit}
      >
        <Row>
          <Col md={4} sm={6}>
            <DateTimePickerField
              colSmInput={8}
              colSmLabel={4}
              disabled={isSearchActive}
              label={t('pageAutomations.messageLog.filters.from')}
              name="from"
            />
          </Col>
          <Col md={4} sm={6}>
            <ActionTypeMultiSelectField
              availableActions={AVAILABLE_FILTER_ACTIONS}
              disabled={isSearchActive}
              label={t('pageAutomations.messageLog.filters.sentVia')}
              name="sentVia"
            />
          </Col>
          <Col md={4} sm={6}>
            <StatusMultiSelectField
              disabled={isSearchActive}
              label={t('pageAutomations.messageLog.filters.status')}
              name="status"
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} sm={6}>
            <DateTimePickerField
              colSmInput={8}
              colSmLabel={4}
              disabled={isSearchActive}
              label={t('pageAutomations.messageLog.filters.to')}
              name="to"
            />
          </Col>
          <Col md={4} sm={6}>
            <PropertyMultiSelectField
              colSmInput={8}
              colSmLabel={4}
              disabled={isSearchActive}
              enableHotels={false}
              enableUnitTypes
              isSelectAllEnabled
              label={t('pageAutomations.messageLog.filters.propertyUid')}
              name="propertyUid"
              placeholder={t('common.selectOption')}
            />
          </Col>
        </Row>

        <FilterFormActions>
          <FilterFormClearButton onClick={handleClear} />
          <FilterFormSubmitButton disabled={isSearchActive} />
        </FilterFormActions>
      </Form>
    </CommonFiltersContainer>
  );
};

export default MessageLogTabFilters;
